import type { MergedCompetency } from './getMergedCompetencies';

interface CompetencySummary {
  expirationDate: string | null;
  grantedOn: string | null;
  grantors: MergedCompetency['grantors'];
}

/**
 * Rebuilds, from an already merged competency, the summary the API returns
 * through _getCompetencySummariesForUsers: everything is read off the highest
 * granted level, the grant date is the earliest grant at that level, and the
 * grantors are sorted by grant date.
 */
const getCompetencySummaryFromMergedCompetency = ({
  competency
}: {
  competency: MergedCompetency;
}): CompetencySummary => {
  const { highestLevel } = competency;

  const grantors = [
    ...((highestLevel?.id
      ? competency.levels?.find((level) => level.id === highestLevel.id)
          ?.grantors
      : competency.grantors) || [])
  ].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );

  const grantTimes = grantors
    .filter((grantor) => grantor.createdAt)
    .map((grantor) => new Date(grantor.createdAt).getTime());

  return {
    expirationDate: (competency.expirationDate as string) || null,
    grantedOn: grantTimes.length
      ? new Date(Math.min(...grantTimes)).toISOString()
      : null,
    grantors
  };
};

export default getCompetencySummaryFromMergedCompetency;
